import { LanguageCodes } from '~/enums/LanguageCodes'
import { useI18n } from '~/composables/useI18n'
import getDefaultLocale from './locale/getDefaultLocale'

export function LanguageManager() {
  const i18n = useI18n()
  const { iso } = getDefaultLocale()
  const localeSetting = useState<string>('locale.setting', () => iso)

  const initWatch = (): void => {
    watch(localeSetting, async (locale: string): Promise<void> => {
      await setLocaleData(locale)
    })
  }

  const setLocaleData = async (locale: string): Promise<void> => {
    await i18n.setCurrentLanguage(locale as LanguageCodes)
  }

  return {
    initWatch,
    setLocaleData,
  }
}
